<template>
  <div>
    <Row>
      <ColumnUi md="12">
        <p v-if="parametros.num">
          <b>Reporte de evento:</b>
          IGP/ACELDAT-PERU
          {{
            `${parametros.num
              .toString()
              .slice(0, 4)}-${parametros.num.toString().slice(4)}`
          }}
        </p>
      </ColumnUi>
    </Row>
    <Row>
      <ColumnUi md="12">
        <p>
          El <b>CENSIS</b> obtiene sus datos de la Red Sísmica Nacional
          <a
            href="https://www.igp.gob.pe/servicios/centro-sismologico-nacional/files/ds_017-2018-minam.pdf"
            target="_blank"
            >(DS-0017-2018MINAM)</a
          >, conformada e integrada por una serie de sensores de velocidad,
          aceleración y desplazamiento distribuidos en todo el país.
        </p>
      </ColumnUi>
    </Row>
    <Row>
      <ColumnUi md="12">
        <p><b>Rango de magnitud: </b></p>
        <Row class="ulcontent-semaforo">
          <ColumnUi xs="12" class="mapa-colores">
            <div class="mapa-colores--item">
              <span class="circle verde"></span>
              <strong class="text-grados"> &lt; M4.5 </strong>
            </div>
            <div class="mapa-colores--item">
              <span class="circle amarillo"></span>
              <strong class="text-grados"> de M4.5 a M6.0 </strong>
            </div>
            <div class="mapa-colores--item">
              <span class="circle rojo"></span>
              <strong class="text-grados"> &gt; M6.0 </strong>
            </div>
          </ColumnUi>
        </Row>
      </ColumnUi>
    </Row>
    <br />
    <Row>
      <ColumnUi md="12">
        <div class="segments  cuadro">
          <div
            class="segment igp-us segment-magnitud"
            :class="colorHeader(parametros)"
          >
            <div class="igp-magnitud-main " :class="colorHeader(parametros)">
              <b> M <br />{{ parametros.mag }}</b>
            </div>
            <br />
            <b>Referencia: </b><span>{{ parametros.ref }}</span>
          </div>
          <div
            class="md-layout-item md-size-100 padding-20 segment-body"
            :class="color(parametros)"
          >
            <slot name="body"> </slot>
          </div>
          <!--  <div class="md-layout md-alignment-center-right">
            <div
              class="md-layout-item md-size-100  segment-bottom"
              :class="color(parametros)"
            ></div>
          </div> -->
        </div>

        <br />
        <br />
      </ColumnUi>
    </Row>
  </div>
</template>

<script>
import Row from "@/components/ui/atoms/Row.vue";
import ColumnUi from "@/components/ui/atoms/ColumnUi.vue";
export default {
  components: {
    Row,
    ColumnUi,
  },
  props: {
    parametros: Object,
  },
  setup() {
    const fechaHora = (fecha) => {
      if (fecha) {
        const optionsDate = {
          year: "numeric",
          month: "2-digit",
          day: "numeric",
        };
        const optionsTime = {
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
        };
        let date = new Date(parseInt(fecha.$date.$numberLong));
        let resp =
          date.toLocaleTimeString("es-PE", optionsTime) +
          " " +
          date.toLocaleDateString("es-PE", optionsDate);
        return resp;
      }
    };
    const colorHeader = (obj) => {
      let magnitud = obj.mag;
      if (magnitud < 4.5) {
        return "verde";
      }
      if (magnitud >= 4.5 && magnitud < 6) {
        return "amarillo";
      }
      if (magnitud >= 6) {
        return "rojo";
      }
    };
    const color = (obj) => {
      let magnitud = obj.mag;
      if (magnitud < 4.5) {
        return "verde-segment-bottom";
      }
      if (magnitud >= 4.5 && magnitud < 6) {
        return "amarillo-segment-bottom";
      }
      if (magnitud >= 6) {
        return "rojo-segment-bottom";
      }
    };

    return {
      color,
      colorHeader,
      fechaHora,
    };
  },
};
</script>

<style style="scoped" lang="scss">
@use "@/assets/styles/settings/_variables.scss";
.circle {
  width: 16px;
  height: 16px;
  padding: 2px;
  margin: 2px;
  border-radius: 25px;
  display: inline-flex;
}
.verde {
  background: #009900 !important;
  border: 2.5px solid #009900 !important;
}
.amarillo {
  color: black !important;
  background: #ffdd00 !important;
  border: 2.5px solid #ffdd00 !important;
}
.rojo {
  background: #e20000 !important;
  border: 2.5px solid #e20000 !important;
  color: white !important;
}
.ulcontent-semaforo > li {
  font-size: 14px;
  line-height: 1.4285em;

  display: inline-block;
  width: 100%;
  background: #ececec;
  margin: 5px;
  padding: 5px;
  border-radius: 2px;
}
.padding-20 {
  padding: 20px;
  line-height: 1.8;
}

.segment-magnitud {
  /* color: #fff !important; */
  z-index: 1;
  position: relative !important;
  height: auto;
  padding-left: 100px !important;
  font-size: 15px !important;
  height: 80px;
  background-color: variables.$primary-color;
  border: 2.5px solid variables.$primary-color;
  border-radius: 10px 10px 0 0 !important;
}
.segment-body {
  border-left: 2.5px solid variables.$primary-color;
  border-right: 2.5px solid variables.$primary-color;
}
.verde-segment-bottom {
  border-left: 2.5px solid variables.$primary-color;
  border-right: 2.5px solid variables.$primary-color;
  border-bottom: 2.5px solid variables.$primary-color;
  border-radius: 0 0 10px 10px !important;
}

.verde-segment-body {
  border-left: 2.5px solid #009900 !important;
  border-right: 2.5px solid #009900 !important;
}
.verde-segment-bottom {
  border-left: 2.5px solid #009900 !important;
  border-right: 2.5px solid #009900 !important;
  border-bottom: 2.5px solid #009900 !important;
}
.rojo-segment-body {
  border-left: 2.5px solid #e20000 !important;
  border-right: 2.5px solid #e20000 !important;
}
.rojo-segment-bottom {
  border-left: 2.5px solid #e20000 !important;
  border-right: 2.5px solid #e20000 !important;
  border-bottom: 2.5px solid #e20000 !important;
}
.amarillo-segment-body {
  border-left: 2.5px solid #ffdd00 !important;
  border-right: 2.5px solid #ffdd00 !important;
}
.amarillo-segment-bottom {
  border-left: 2.5px solid #ffdd00 !important;
  border-right: 2.5px solid #ffdd00 !important;
  border-bottom: 2.5px solid #ffdd00 !important;
}

.igp-magnitud-main {
  animation: pulse 2s infinite;
  width: 80px;
  height: 80px;
  border-radius: 85px;
  border: 2px solid #fff !important;
  position: absolute;
  text-align: center;
  z-index: 2;
  top: 0px;
  left: 0px;
  font-size: 25px;
  line-height: 28px;
  display: flex;
  background-color: variables.$primary-color;
  align-items: center;
  justify-content: center;
}
@keyframes pulse {
  0% {
    /* transform: scale(0.95); */
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.7);
  }

  70% {
    /* transform: scale(1); */
    box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
  }

  100% {
    /* transform: scale(0.95); */
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
  }
}
.mapa-colores {
  display: flex;
}
.mapa-colores--item {
  display: flex;
  align-items: center;
  margin: 0 10px 0 0;
}

@media (max-width: 440px) {
  .mapa-colores {
    display: grid;
  }
  .mapa-colores--item:not(:last-child) {
    margin-bottom: 1rem;
  }
}
</style>
